import React, { useState } from "react";

import "../../acesso-rapido/pix/Style.css"

import api, { apiUrl } from "../../../services/api"
import axios from 'axios';

import { Link, useNavigate } from "react-router-dom"
import IntlCurrencyInput from "react-intl-currency-input"
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import 'react-toastify/dist/ReactToastify.min.css';
import { css } from "@emotion/react";
import BeatLoader from "react-spinners/BeatLoader";


export default function () {
    const [valor, setValor] = useState(0);
    const [chave, setChave] = useState('');
    const [tipoChave, setTipoChave] = useState('');
    const [cpf, setCpf] = useState('');
    const [cpfTo, setToCpf] = useState('');
    const [description, setDescription] = useState('');
    const [response, setResponse] = useState({});

    const [receipt, setReceipt] = useState(false)
    const [loader, setLoader] = useState(false)

    const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;

    const currencyConfig = {
        locale: "pt-BR",
        formats: {
            number: {
                BRL: {
                    style: "currency",
                    currency: "BRL",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                },
            },
        },
    };

    const handleChange = (event, value, maskedValue) => {
        event.preventDefault();

        setValor(value); // value without mask (ex: 1234.56)
        console.log(maskedValue); // masked value (ex: R$1234,56)
    };

    async function sendpix() {
        setLoader(true)

        if (valor == '' || chave == '' || tipoChave == '') {
            toast.error('Preencha todos os campos!')
            setLoader(false)
            return;
        }

        const body = {
            'value': valor,
            'keyType': tipoChave,
            'key': chave,
            'fromTaxNumber': localStorage.getItem('taxNumber'),
            'toTaxNumber': cpfTo,
            'description': description
        }

        const obj = {
            username: localStorage.getItem('taxNumber'),
            password: localStorage.getItem('identifier'),
            mac: localStorage.getItem('deviceId'),
            login: localStorage.getItem('login')
        }

        await api.post('/login/token', obj)
            .then(async function (result) {
                await localStorage.setItem('token', result.data.token)

                const api2 = await axios.create({
                    headers: {
                        'Authorization': result.data.token,
                        'device': localStorage.getItem('deviceId')
                    },
                    baseURL: apiUrl
                })

                var callPix = await api2.post('/pix/transfer', body)
                    .catch(err => {
                        setLoader(false)
                        toast.error(err.response.data.message)
                        return;
                    })


                var response = callPix.data.data;
                toast.success('Pix Enviado com sucesso!')
                setResponse(response)
                console.log(response)

                setLoader(false);
                setReceipt(true)
                setValor('')
                setTipoChave('')
                setDescription('')
            })
    }


    return (
        <div>
            <div className="transferencia-pix">
                <div className="container">
                    <div className='pix row'>
                        <div className='col-xl-8'>
                            <p>Pix</p>
                        </div>

                        <div className="col-xl-2">
                            <Link to={"/chave-pix"}>
                                <button style={{ backgroundColor: "var(--secondary-color)" }}>Minhas Chaves</button>
                            </Link>
                        </div>
                        <div className="col-xl-2">
                            <Link to={"/nova-chave-pix"}>
                                <button style={{ backgroundColor: "var(--secondary-color)" }}>Cadastrar Chave</button>
                            </Link>
                        </div>
                    </div>

                    <div className="transferencia">
                        <div className="row">
                            <div className="scroll col-xl-6">

                                <div>
                                    <h1>Nova transferência</h1>
                                </div>

                                <div>
                                    <h2>Qual valor você deseja transferir?</h2>
                                </div>

                                <div>
                                    <p style={{ 'marginBottom': '5px' }}>Valor</p>
                                    <IntlCurrencyInput currency="BRL" config={currencyConfig}
                                        onChange={handleChange}
                                        placeholder="Digite o valor a ser transferido"
                                        value={valor}
                                    // onChange={e => { setValor(e.target.value) }}
                                    />
                                </div>

                                <div>
                                    <h2>Para quem você quer transferir</h2>
                                </div>

                                <div style={{ 'marginTop': '15px' }}>
                                    <p style={{ 'marginBottom': '5px' }}>Tipo de chave</p>
                                    <div className='seleciona'>
                                        <select name="select" value={tipoChave} onChange={e => { setTipoChave(e.target.value) }}>
                                            <option value="">Selecione um tipo</option>
                                            <option value="0">CPF</option>
                                            <option value="1">CNPJ</option>
                                            <option value="2">E-mail</option>
                                            <option value="3">Número de telefone celular</option>
                                            <option value="4">Chave aleatória</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="chave">
                                    <p style={{ 'marginBottom': '5px' }}>Chave</p>
                                    <input type="text"
                                        placeholder="Digite a chave"
                                        value={chave}
                                        onChange={e => { setChave(e.target.value) }} />
                                </div>
                                <div style={{ 'marginTop': '15px' }} className="description">
                                    <p style={{ 'marginBottom': '5px' }}>Descrição</p>
                                    <textarea type="text"
                                        placeholder="Digite a descrição do pagamento"
                                        value={description}
                                        onChange={e => { setDescription(e.target.value) }} />
                                </div>
                            </div>

                            <div className="col-xl-6">
                                <div className="resumo-transferencia">
                                    <div>
                                        <h1>Resumo da transferência</h1>
                                    </div>

                                    <div style={receipt ? { 'display': 'block' } : { 'display': 'none' }}>
                                        <div>
                                            <h2>{response.toName}</h2>
                                        </div>

                                        <div>
                                            <p>CPJ/CNPJ</p>
                                            <h4>{response.toTaxNumber}</h4>
                                        </div>

                                        <div>
                                            <p>Chave</p>
                                            <h4>{chave}</h4>
                                        </div>

                                        <div>
                                            <p>Banco</p>
                                            <h4>{response.toBank}</h4>
                                        </div>

                                        <div className="agencia">
                                            <div className="row">
                                                <div className="col-xl-6">
                                                    <p>Agência</p>
                                                    <h4>{response.toBankBranch}</h4>
                                                </div>

                                                <div className="col-xl-6">
                                                    <p>Conta</p>
                                                    <h4>{response.toBankAccount + '-' + response.toBankAccountDigit}</h4>
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <p>Valor</p>
                                            <h4>R$ {response.value}</h4>
                                        </div>

                                        <div>
                                            <h3>Quando será transferido</h3>
                                            <h4>Agora</h4>
                                        </div>
                                    </div>

                                    <div style={loader ? { 'display': 'block', 'margin': 'auto', 'marginTop': '20px' } : { 'display': 'none' }}>
                                        <BeatLoader color={"var(--secondary-color)"} loading={loader} css={override} size={20} />
                                    </div>
                                </div>

                                <div className="botao-confirmar">
                                    <button
                                        style={loader ? { 'display': 'none' } : { 'display': 'block' }}
                                        onClick={() => sendpix()}>Confirmar transferência
                                    </button>

                                    <button
                                        style={loader ? { 'display': 'block' } : { 'display': 'none' }}
                                        onClick={() => toast.info('Requisição em processamento!')} >
                                        <BeatLoader color={"#fff"} loading={loader} css={override} size={10} />
                                    </button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}